import React from 'react';

import { useIntl } from 'react-intl';

import { useOrderHref } from 'hooks/use-order-href';
import { routes } from 'utils/routing';

import { messages } from '../app-subheader-messages';

import ChangeServiceModeLinkContents from './change-service-mode-link-contents';
import { ChangeServiceModeLinkProps } from './types';

export const getRouteForLink = (isOrderingEnabled: boolean, nonCateringRoute: string) => {
  if (!isOrderingEnabled) {
    return routes.storeLocator;
  }
  return nonCateringRoute;
};

const ChangeServiceModeLink: React.FC<ChangeServiceModeLinkProps> = ({
  storeSelected = true,
  orderingEnabled = true
}) => {
  const { formatMessage } = useIntl();
  const nonCateringRoute = useOrderHref({ forceStoreChange: true });

  const linkText = formatMessage(
    !storeSelected && !orderingEnabled ? messages.selectRestaurant : messages.change
  );

  const linkRoute = getRouteForLink(orderingEnabled, nonCateringRoute);

  return (
    <ChangeServiceModeLinkContents
      linkText={linkText}
      linkRoute={linkRoute}
      orderingEnabled={orderingEnabled}
    />
  );
};

export default ChangeServiceModeLink;
